import { useEffect, useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PasswordField } from 'Common/Form';

const formFieldNames = {
  password: 'password',
  confirmPassword: 'confirmPassword'
} as const;

type Props = {
  formContext: UseFormReturn<any>;
  passwordLabel?: string;
  confirmPasswordLabel?: string;
};

export const PasswordAndConfirmPasswordFields = ({
  formContext,
  passwordLabel,
  confirmPasswordLabel
}: Readonly<Props>) => {
  const { t } = useTranslation();

  const [passwordsNotMatch, setPasswordsNotMatch] = useState<boolean>();

  const passwordValue = formContext.watch(formFieldNames.password);
  const confirmPasswordValue = formContext.watch(formFieldNames.confirmPassword);

  useEffect(() => {
    if (passwordValue && confirmPasswordValue && passwordValue !== confirmPasswordValue) {
      setPasswordsNotMatch(true);
    } else {
      setPasswordsNotMatch(false);
    }
  }, [passwordValue, confirmPasswordValue]);

  return (
    <>
      <PasswordField name={formFieldNames.password} label={passwordLabel} />

      <PasswordField
        name={formFieldNames.confirmPassword}
        label={confirmPasswordLabel ?? t('auth.confirmPassword')}
        helperText={passwordsNotMatch ? t('password_not_match') : ''}
        error={passwordsNotMatch}
      />
    </>
  );
};
